var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loader w-100 h-100"},[_c('div',{staticClass:"w-100 h-75 d-flex justify-content-center align-items-center"},[_c('div',[_c('div',{staticClass:"d-flex justify-content-between mt-3"},[_c('b-spinner',{attrs:{"variant":_vm.color}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }